var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.person.legal_nature === 'F')?_c('KChip',{attrs:{"color":"orange"}},[_vm._v("Pessoa Física")]):(_vm.person.legal_nature === 'J')?_c('KChip',{attrs:{"color":"purple"}},[_vm._v("Pessoa Jurídica")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }